export class SearchRequestDetailModel {
  public requestId: string;
  public cdcNo: string;
  public cocNo: string;
  public sidNo: string;
  public date: string[];
  public status: string;
  public biometricStatus:string;
  public dataverification:string;


  constructor(requestId: string, cdcNo: string, cocNo: string, date: string[], status: string,biometricStatus:string, dataverification:string,sidNo:string) {
    this.requestId = requestId;
    this.cdcNo = cdcNo;
    this.cocNo = cocNo;
    this.date = date;
    this.status = status;
    this.biometricStatus=biometricStatus;
    this.dataverification=dataverification;
    this.sidNo=sidNo;
  }
}
